import { render } from "./mped-fact-file-uploader-step.vue?vue&type=template&id=48352a55"
import script from "./mped-fact-file-uploader-step.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-fact-file-uploader-step.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/components/mped-calculation-upload/mped-fact-file-uploader-step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48352a55"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48352a55', __exports__)) {
    api.reload('48352a55', __exports__)
  }
  
  module.hot.accept("./mped-fact-file-uploader-step.vue?vue&type=template&id=48352a55", () => {
    api.rerender('48352a55', render)
  })

}


export default __exports__